import { Inbox, FileText, BadgeCheck, Wrench, PackageCheck, Handshake, Check, Ban } from "lucide-react";
import { useTranslation } from "react-i18next";
import { STAGES, normalizeStatus, stageIndex, phaseOf } from "@/lib/api";

const ICONS = [Inbox, FileText, BadgeCheck, Wrench, PackageCheck, Handshake];

const PHASE_ACTIVE = {
  blue: "border-blue-600 bg-blue-600 text-white shadow-md shadow-blue-600/30",
  amber: "border-amber-500 bg-amber-500 text-white shadow-md shadow-amber-500/30",
  emerald: "border-emerald-500 bg-emerald-500 text-white shadow-md shadow-emerald-500/30",
};
const PHASE_LABEL = {
  blue: "text-blue-700",
  amber: "text-amber-600",
  emerald: "text-emerald-600",
};

export function Stepper({ status, compact = false }) {
  const { t } = useTranslation();
  const norm = normalizeStatus(status);
  if (norm === "annulee") {
    return (
      <div className="flex items-center gap-2 rounded-lg bg-rose-50 px-3 py-2 text-sm font-medium text-rose-600" data-testid="stepper-cancelled">
        <Ban className="h-4 w-4" /> {t("stages.cancelled")}
      </div>
    );
  }
  const current = stageIndex(status);
  const phase = phaseOf(status);
  const activeCls = PHASE_ACTIVE[phase] || PHASE_ACTIVE.blue;
  const activeLabelCls = PHASE_LABEL[phase] || PHASE_LABEL.blue;

  return (
    <div className="flex items-center" data-testid="stepper">
      {STAGES.map((stage, i) => {
        const Icon = ICONS[i];
        const done = i < current;
        const active = i === current;
        return (
          <div key={stage.key} className="flex flex-1 items-center last:flex-none" data-testid={`step-${stage.key}`}>
            <div className="flex flex-col items-center">
              <span
                className={`grid place-items-center rounded-full border-2 transition-all duration-300 ${compact ? "h-7 w-7" : "h-9 w-9"} ${
                  done
                    ? "border-emerald-500 bg-emerald-500 text-white"
                    : active
                    ? `${activeCls} scale-110`
                    : "border-slate-200 bg-white text-slate-300"
                }`}
              >
                {done ? <Check className={compact ? "h-3.5 w-3.5" : "h-4 w-4"} /> : <Icon className={compact ? "h-3.5 w-3.5" : "h-4 w-4"} />}
              </span>
              {!compact && (
                <span className={`mt-2 max-w-[84px] text-center text-[11px] font-medium leading-tight ${active ? activeLabelCls : done ? "text-emerald-600" : "text-slate-400"}`}>
                  {t(`stages.${stage.key}_l`)}
                </span>
              )}
            </div>
            {i < STAGES.length - 1 && (
              <div className={`mx-1.5 h-0.5 flex-1 rounded-full transition-colors duration-300 ${i < current ? "bg-emerald-500" : "bg-slate-200"} ${compact ? "" : "mb-5"}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}
